import { HelperResult, Milestone } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useUserProjectSectionMilestone,
  useFind: useUserProjectSectionMilestones,
  useCreate: useUserProjectSectionMilestonesCreation,
  useUpdate: useUserProjectSectionMilestonesUpdate,
} = getCRUDHooks({
  entityName: 'userProjectSectionMilestones',
  get: ({ userId, projectId, sectionId, milestoneId }): HelperResult<Milestone> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .projects.id(projectId)
      .sections.id(sectionId)
      .milestones.get(milestoneId),
  find: ({ userId, projectId, sectionId }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .projects.id(projectId)
      .sections.id(sectionId)
      .milestones.find(),
  create: ({ userId, projectId, sectionId, title, content }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .projects.id(projectId)
      .sections.id(sectionId)
      .milestones.create({ title, content }),
  update: (values, { userId, projectId, sectionId, milestoneId }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .projects.id(projectId)
      .sections.id(sectionId)
      .milestones.partialUpdate(milestoneId, values),
});

export {
  useUserProjectSectionMilestone,
  useUserProjectSectionMilestones,
  useUserProjectSectionMilestonesCreation,
  useUserProjectSectionMilestonesUpdate,
};
